import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
    selector: "vsf-order-totals",
    templateUrl: "./order-totals.component.html",
    styleUrls: ["./order-totals.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderTotalsComponent {
    @Input() subtotal = 0;
    @Input() vat = 0;
    @Input() total = 0;

    @Input() subtotalLabel = "Subtotal";
    @Input() shippingLabel = "Shipping with protection";
    @Input() shippingValue = "Included";
    @Input() shippingAmount: number | null = null;
    @Input() vatLabel = "VAT";
    @Input() totalLabel = "Total";

    @Input() showProcessingFee = false;
    @Input() processingFee = 0;
    @Input() processingFeeLabel = "Processing fee";

    @Input() showTaxableSubtotal = false;
    @Input() taxableSubtotal = 0;
    @Input() taxableSubtotalLabel = "Taxable subtotal";

    @Input() discountLabel = "Discount";
    @Input() discountAmount = 0;

    @Input() variant: "default" | "card" = "default";

    get hasDiscount(): boolean {
        return this.discountAmount !== 0;
    }
}
